<form ng-submit="summaryContactModal.ok()" novalidate>
  <div class="modal-header oqs-summary-modal-header">
    <button type="button" class="close" aria-label="Close"
            ng-click="summaryContactModal.cancel()"
            ng-disabled="summaryContactModal.data.quoteConfirmationInProgress">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" oqs-message="confirmation.heading.confirmationHeading"></h4>
  </div>

  <div class="modal-body oqs-summary-modal-body">
    <p oqs-message="confirmation.html.confirmationBody" oqs-message-html></p>
    <uib-tabset justified="true" class="oqs-tab-animation">
      <uib-tab disable="summaryContactModal.data.quoteConfirmationResponse || summaryContactModal.data.quoteConfirmationInProgress" select="summaryContactModal.setPreferredContactMethod('Phone')">
        <uib-tab-heading>
          <span class="fa fa-phone"></span> <span oqs-message="confirmation.tab.callMeTabHeading">Call Me</span>
        </uib-tab-heading>
        <div ng-form="summaryContactModal.forms.oqsContactPhone">
          <p oqs-message="confirmation.html.confirmationCallMeBody" oqs-message-html></p>
          <div class="form-group">
            <label for="phoneNumber" oqs-message="confirmation.label.confirmationPhoneNumberLabel">Your phone number?</label>
            <input ng-model="summaryContactModal.contactInfo.phoneNumber" class="form-control" type="tel" id="phoneNumber"
                   ng-required="true"
                   placeholder="555-555-1234"
                   ng-pattern="summaryContactModal.phoneNumberPattern"
                   ng-change="summaryContactModal.updatePhoneNumber()"
              />
          </div>
          <div class="form-group">
            <label oqs-message="confirmation.label.confirmationPhoneTimeLabel"></label>
            <div class="oqs-radio-buttons btn-group btn-group-justified">
              <label class="btn btn-default" ng-model="summaryContactModal.contactInfo.phoneTime"
                     uib-btn-radio="'anytime'">Anytime</label>
              <label class="btn btn-default" ng-model="summaryContactModal.contactInfo.phoneTime"
                     uib-btn-radio="'morning'">Morning</label>
              <label class="btn btn-default" ng-model="summaryContactModal.contactInfo.phoneTime"
                     uib-btn-radio="'afternoon'">Afternoon</label>
              <label class="btn btn-default" ng-model="summaryContactModal.contactInfo.phoneTime"
                     uib-btn-radio="'evening'">Evening</label>
            </div>
          </div>
        </div>
      </uib-tab>
      <uib-tab disable="summaryContactModal.data.quoteConfirmationResponse || summaryContactModal.data.quoteConfirmationInProgress" select="summaryContactModal.setPreferredContactMethod('Email')">
        <uib-tab-heading>
          <span class="fa fa-envelope"></span> <span oqs-message="confirmation.tab.confirmationEmailMeTabHeading"></span>
        </uib-tab-heading>
        <div ng-form="summaryContactModal.forms.oqsContactEmail">
          <div class="form-group">
            <p oqs-message="confirmation.html.confirmationEmailBody" oqs-message-html></p>
            <label for="emailAddress" oqs-message="confirmation.label.confirmationEmailLabel"></label>
            <input type="email" ng-model="summaryContactModal.contactInfo.emailAddress" class="form-control" id="emailAddress"
                   ng-pattern="summaryContactModal.emailPattern"
                   ng-required="true"
                   placeholder="you@domain.com"/>
          </div>
        </div>
      </uib-tab>
      <uib-tab disable="summaryContactModal.data.quoteConfirmationResponse || summaryContactModal.data.quoteConfirmationInProgress" select="summaryContactModal.setPreferredContactMethod('Will Contact Us')">
        <uib-tab-heading>
          <span class="fa fa-send"></span> <span oqs-message="confirmation.tab.contactUsTabHeading"></span>
        </uib-tab-heading>
        <div ng-form="oqsContactUs">
          <p oqs-message="confirmation.html.confirmationContactUsBody" oqs-message-html></p>
          <p>
            <strong>{{summaryContactModal.data.selectedBroker.name}}</strong>
            <div class="oqs-broker-address">{{summaryContactModal.data.selectedBroker.address}}</div>
            <div ng-if="summaryContactModal.data.selectedBroker.phoneNumber" class="oqs-broker-phone" ng-bind="summaryContactModal.data.selectedBroker.phoneNumber | tel">
            </div>
            <a ng-if="summaryContactModal.data.selectedBroker.website" ng-href="{{summaryContactModal.data.selectedBroker.website}}" title="{{summaryContactModal.data.selectedBroker.website}}" target="_blank">
              <span class="fa fa-globe"></span> Website
            </a>
          </p>
        </div>
      </uib-tab>
    </uib-tabset>
    <uib-alert type="danger" ng-if="summaryContactModal.data.quoteConfirmationResponse && summaryContactModal.data.quoteConfirmationResponse.status!=200">
      <span class="fa fa-exclamation"></span> <span oqs-message="confirmation.html.confirmationErrorMessage" oqs-message-html></span>
    </uib-alert>
    <uib-alert type="success"
               ng-if="summaryContactModal.data.quoteConfirmationResponse && summaryContactModal.data.quoteConfirmationResponse.status==200">
      <span class="fa fa-check"></span>
      <span ng-show="$parent.summaryContactModal.contactInfo.preferredMethod === 'Email'" oqs-message="confirmation.html.emailConfirmationSuccessfulMessage" oqs-message-html></span>
      <span ng-show="$parent.summaryContactModal.contactInfo.preferredMethod === 'Phone'" oqs-message="confirmation.html.phoneConfirmationSuccessfulMessage" oqs-message-html></span>
      <span ng-show="$parent.summaryContactModal.contactInfo.preferredMethod === 'Will Contact Us'" oqs-message="confirmation.html.contactUsConfirmationSuccessfulMessage" oqs-message-html></span>
       <span>Your quote ID is {{summaryContactModal.data.quoteConfirmationResponse.data.quoteConfirmationId}}.</span>
    </uib-alert>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" ng-click="summaryContactModal.openQuoteSummaryPdf()"
            ng-if="summaryContactModal.data.quoteConfirmationResponse && summaryContactModal.data.quoteConfirmationResponse.status==200">
          <span class="summary fa fa-file-pdf-o"
                ng-class="{'fa-file-pdf-o': !summaryContactModal.downloadInProgress, 'fa-spinner fa-pulse': summaryContactModal.downloadInProgress}"></span>
      <span class="summary oqs-label" oqs-message="confirmation.button.DownloadQuoteButton"></span>
    </button>
    <button ng-hide="summaryContactModal.data.quoteConfirmationResponse" class="btn" type="submit"
            ng-disabled="summaryContactModal.isSubmitDisabled()"
            ng-class="{'btn-default': summaryContactModal.isSubmitDisabled(), 'btn-primary': !summaryContactModal.isSubmitDisabled()}">
      <span ng-if="summaryContactModal.data.quoteConfirmationInProgress" class="fa fa-spinner fa-pulse"></span>
      <span oqs-message="confirmation.button.confirmationSubmitButton"></span>
    </button>
    <button class="btn btn-default" type="button"
            ng-click="summaryContactModal.cancel()"
            ng-disabled="summaryContactModal.data.quoteConfirmationInProgress">
      <span oqs-message="confirmation.button.confirmationCancelButton"></span>
    </button>
  </div>
</form>
